<ng-container *ngFor="let item of template">

    <lib-form-builder-item [elemento]="item" [readonly]="readonly"></lib-form-builder-item>

</ng-container>

